module.exports = __webpack_public_path__ + "images/stickers/thumbsup.ebab8d33a9e50bfb9272.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/thumbsup.png
// module id = qsG6
// module chunks = 13